import React, { FC, useEffect } from 'react';
import styled from 'styled-components';
import { yupResolver } from '@hookform/resolvers';
import { Controller, useForm } from 'react-hook-form';
import { Button } from '@material-ui/core';
import ReactInputMask from 'react-input-mask';
import { useParams } from 'react-router';
import { useSelector } from 'react-redux';
import { useAddWikiInspectionMutation, useUpdateWikiInspectionMutation } from '../../../redux/rtkQuery/apiWikiInspectionSlice';
import { WikiInspectionType } from '../../../api/jurisdiction';
import { schema } from './Schema';
import { InputTextWithLabel } from '../../../molecules';
import { RootState } from '../../../redux/root';

type Props = {
  defaultValues: WikiInspectionType;
  setShowPopup: Function;
  setDefaultValues: Function;
};
const ContactDataPopup: FC<Props> = ({ defaultValues, setDefaultValues, setShowPopup }) => {
  const [addWikiInspection] = useAddWikiInspectionMutation();
  const [updateWikiInspection] = useUpdateWikiInspectionMutation();
  // @ts-ignore
  const { wikiId } = useParams();
  const selectedJurisdiction = useSelector((s: RootState) => s.wikiSlice.selectedJurisdiction);
  const { handleSubmit, errors, register, control, reset } = useForm({
    resolver: yupResolver(schema),
    defaultValues,
  });

  useEffect(() => {
    if (defaultValues) {
      reset(defaultValues);
    }
  }, [defaultValues]);
  const onSubmit = async data => {
    const json = JSON.stringify([{ request_or_result: 'adfas' }, { request_or_result: 'adfaasfass' }]);
    const { boContactPerson, boInspectionEmail, boInspectionPhone } = data;
    const formData = new FormData();
    formData.append('jurisdiction', wikiId);
    formData.append('bo_contact_person', boContactPerson);
    formData.append('bo_inspection_email', boInspectionEmail);
    formData.append('bo_inspection_phone', boInspectionPhone);
    formData.append('inspection_request_steps[0]', 'sdf');
    formData.append('inspection_request_steps[1]', 'sdfssdf');
    let result;
    if (selectedJurisdiction.inspection && selectedJurisdiction.inspection.id) {
      // update existing data
      const arg = {
        formData,
        id: selectedJurisdiction.inspection.id,
      };
      result = await updateWikiInspection(arg);
    } else {
      // create new data
      result = await addWikiInspection(formData);
    }
    setDefaultValues(result.data);
    setShowPopup(false);
  };

  return (
    <Wrapper>
      <form autoComplete="off" aria-autocomplete="none" onSubmit={handleSubmit(onSubmit)}>
        <InputTextWithLabel name="boContactPerson" error={errors.boContactPerson} inputRef={register} label="Contact Person" />
        <InputTextWithLabel name="boInspectionEmail" error={errors.boInspectionEmail} inputRef={register} label="Email" />
        <Controller
          control={control}
          name="boInspectionPhone"
          render={props => (
            <ReactInputMask
              mask="999-999-9999"
              maskChar=" "
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...props}
            >
              {() => <InputTextWithLabel error={errors.boInspectionPhone} label="Phone" />}
            </ReactInputMask>
          )}
        />
        <Buttons>
          <Button variant="contained" color="primary" onClick={e => setShowPopup(false)}>
            Cancel
          </Button>
          <Button variant="contained" color="primary" type="submit">
            Save
          </Button>
        </Buttons>
      </form>
    </Wrapper>
  );
};

export default ContactDataPopup;

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-evenly;
  margin-top: 5px;
  button {
    width: 153px;
  }
`;

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  right: calc(100% + 8px);
  width: 340px;
  max-width: calc(100vw - 48px);
  padding: 16px;
  background-color: var(--neutral-0);
  z-index: 20;
  border: 1px solid var(--border);
  border-radius: 10px;
  box-shadow: var(--shadow-lg, 0 12px 24px rgba(15, 23, 42, 0.12));
`;
